import { Link, Navigate, useLocation } from "react-router-dom";
import { useJourneyAuth } from "../../auth/AuthContext";
import { MANUAL_ROLES } from "../../auth/session";
import { getManual } from "../../manuals";
import { parseFilmSearch, withFilmQuery } from "@tour/film.js";

export default function ManualsIndex() {
  const { session, role } = useJourneyAuth();
  const { search } = useLocation();
  const filmOn = parseFilmSearch(search).on;
  if (!filmOn && role && MANUAL_ROLES.includes(role)) {
    return <Navigate to={withFilmQuery(`/manuals/${role}`, search)} replace />;
  }

  const showBooks = filmOn || session?.role === "admin";

  return (
    <article className="prose-page" data-tour="manuals">
      <h1>User manuals</h1>
      <p className="lead">
        Four books for REChecklist, hosted here behind a sign-in. The Guided Tour is the film. These
        pages are the book you keep beside the desk.
      </p>
      {showBooks ? (
        <ul className="door-list" data-tour="manuals-links">
          {MANUAL_ROLES.map((item) => {
            const pack = getManual(item);
            return (
              <li key={item}>
                <Link to={withFilmQuery(`/manuals/${item}`, search)}>{pack.meta.title}</Link>
                <span>{pack.meta.kicker}</span>
              </li>
            );
          })}
        </ul>
      ) : (
        <p>
          <Link className="btn" to={withFilmQuery("/login", search)}>
            Sign in to open your book
          </Link>
        </p>
      )}
    </article>
  );
}
